import { render, staticRenderFns } from "./CollaborateIcon.vue?vue&type=template&id=13753c29"
import script from "./CollaborateIcon.vue?vue&type=script&lang=js"
export * from "./CollaborateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports